import lodashDebounce from 'lodash.debounce'
import lodashGet from 'lodash.get'
import axios from './axios'

const responses = {}

export const debounce = lodashDebounce
export const getProp = lodashGet

export function capitalize (v) {
  if (v) {
    return v.substring(0, 1).toUpperCase() + v.substring(1)
  }
}

export function popup (v, url) {
  const win = window.open(url, '_blank')
  if (win) {
    win.focus()
  } else {
    v.$notify({
      type: 'error',
      title: 'Pop up was blocked',
      text: 'Please allow pop ups and try again.',
      duration: 10000,
    })
  }
}

export function getTypes (channelId) {
  return new Promise((resolve, reject) => {
    return axios.get('/channels/' + channelId + '/content-types')
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error.response)
        })
  })
}

let channelsResponse = null

export function getChannels () {
  return new Promise((resolve, reject) => {
    if (channelsResponse) {
      return resolve(channelsResponse)
    }

    return axios.get('/channels')
        .then((response) => {
          channelsResponse = response
          resolve(response)
        }).catch((error) => {
          reject(error.response)
        })
  })
}

let assetClassesResponse = null

export function getAssetClasses () {
  return new Promise((resolve, reject) => {
    if (assetClassesResponse) {
      return resolve(assetClassesResponse)
    }

    return axios.get('/asset-classes')
        .then((response) => {
          assetClassesResponse = response
          resolve(response)
        }).catch((error) => {
          reject(error.response)
        })
  })
}

let dataProvidersResponse = null

export function getDataProviders () {
  return new Promise((resolve, reject) => {
    if (dataProvidersResponse) {
      return resolve(dataProvidersResponse)
    }

    return axios.get('/data-providers')
        .then((response) => {
          dataProvidersResponse = response
          resolve(response)
        }).catch((error) => {
          reject(error.response)
        })
  })
}

let analystsResponse = null
const channelAnalystsResponse = {}

export function getAnalysts (channelId = null) {
  return new Promise((resolve, reject) => {
    if (!channelId && analystsResponse) {
      return resolve(analystsResponse)
    }

    if (channelId && channelAnalystsResponse[channelId]) {
      return resolve(channelAnalystsResponse[channelId])
    }

    return axios.get(channelId ? `/channels/${channelId}/analysts` : '/analysts')
        .then((response) => {
          if (channelId) {
            channelAnalystsResponse[channelId] = response
          } else {
            analystsResponse = response
          }
          resolve(response)
        }).catch((error) => {
          reject(error.response)
        })
  })
}

export function isEquivalent (a, b) {
  const aProps = Object.getOwnPropertyNames(a)
  const bProps = Object.getOwnPropertyNames(b)

  if (aProps.length !== bProps.length) {
    return false
  }

  for (let i = 0; i < aProps.length; i++) {
    const propName = aProps[i]

    if (a[propName] !== b[propName]) {
      return false
    }
  }

  return true
}

// pass to string.replace for camel to hyphen
const hyphenate = function (a, b, c) {
  return b + '-' + c.toLowerCase()
}

// get computed style property
const getStyle = function (target, prop) {
  if (window.getComputedStyle) { // gecko and webkit
    prop = prop.replace(/([a-z])([A-Z])/, hyphenate) // requires hyphenated, not camel
    return window.getComputedStyle(target, null).getPropertyValue(prop)
  }
  if (target.currentStyle) {
    return target.currentStyle[prop]
  }
  return target.style[prop]
}

export function getUnits (target, prop) {
  const baseline = 100 // any number serves
  let item // generic iterator

  const map = { // list of all units and their identifying string
    pixel: 'px',
    percent: '%',
    inch: 'in',
    cm: 'cm',
    mm: 'mm',
    point: 'pt',
    pica: 'pc',
    em: 'em',
    ex: 'ex',
  }

  const factors = {} // holds ratios
  const units = {} // holds calculated values

  const value = getStyle(target, prop) // get the computed style value

  let numeric = value.match(/\d+/) // get the numeric component
  if (numeric === null) { // if match returns null, throw error...  use === so 0 values are accepted
    throw new DOMException('Invalid property value returned')
  }
  numeric = numeric[0] // get the string

  let unit = value.match(/\D+$/) // get the existing unit
  unit = (unit === null) ? map.pixel : unit[0] // if its not set, assume px - otherwise grab string

  let activeMap // a reference to the map key for the existing unit
  for (item in map) {
    if (map[item] === unit) {
      activeMap = item
      break
    }
  }
  if (!activeMap) { // if existing unit isn't in the map, throw an error
    throw new DOMException('Unit not found in map')
  }

  const temp = document.createElement('div') // create temporary element
  temp.style.overflow = 'hidden' // in case baseline is set too low
  temp.style.visibility = 'hidden' // no need to show it

  target.parentElement.appendChild(temp) // insert it into the parent for em and ex

  for (item in map) { // set the style for each unit, then calculate it's relative value against the baseline
    if (map[item] !== undefined) {
      temp.style.width = baseline + map[item]
      factors[item] = baseline / temp.offsetWidth
    }
  }
  // do we need two for loops here?
  for (item in map) { // use the ratios figured in the above loop to determine converted values
    if (map[item] !== undefined) {
      units[item] = numeric * (factors[item] * factors[activeMap])
    }
  }

  target.parentElement.removeChild(temp) // clean up

  return units // returns the object with converted unit values...
}

  export function createHttpQuery (params) {
  const finalParams = {}
  let val
  let key

  for (key in params) {
    if (params[key] !== undefined && params[key] !== null) {
      val = params[key]
      if (val === true) {
        finalParams[key] = 1
      } else if (val === false) {
        finalParams[key] = 0
      } else {
        finalParams[key] = params[key]
      }
    }
  }

  return finalParams
}

let sectorsResponse = null

export function getSectors () {
  return new Promise((resolve, reject) => {
    if (sectorsResponse) {
      return resolve(sectorsResponse)
    }

    return axios.get('/sectors?populate[]=microSectors')
        .then((response) => {
          sectorsResponse = response.data
          resolve(response.data)
        }).catch((error) => {
          reject(error.response)
        })
  })
}

export function getArticle (articleId, cb) {
  axios.get('/articles/' + articleId).then((response) => {
    cb(null, response.data)
  })
}

export function get (what, params, config = {}) {
  return axios.get(`/${what}`, Object.assign(config, {params}))
}

export function getOnce (what, params, config = {}) {
  return new Promise((resolve, reject) => {
    if (responses[what]) {
      return resolve(responses[what])
    }

    get(what, params, config).then((response) => {
      responses[what] = response
      resolve(response)
    }).catch((response) => reject(response))
  })
}

export function search (what, query, params = {}) {
  if (!query) {
    return new Promise((resolve, reject) => {
      resolve({
        data: [],
      })
    })
  }

  params.q = query

  return new Promise((resolve, reject) => {
    axios.get(`/${what}/search/`, {
      params,
    })
        .then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error.response)
        })
  })
}

export function articleHeader (article) {
  return article.display_title || article.title || 'Untitled'
}

export function toSentenceCase (theString) {
  return theString.toLowerCase().replace(/(^\s*\w|[.!?]\s*\w)/g, (c) => c.toUpperCase())
}
